import {
  AppearAnimation,
  Translate,
} from '../../../elements/resource/types/shape.type';
import { ImageShape } from '../../shape/shapes/base/image-shape';
import { GeneralShape } from '../../shape/shapes/general/general-shape';
import { RootShape } from '../../shape/shapes/general/root/root-shape';
import { AutoAnimationFrame } from '../components/animation-frame/animation.types';
import { AnimationFrameObject } from './animation-frame-object';

export type AnimationId = string;

export class AutoAnimationFrameObject extends AnimationFrameObject<AutoAnimationFrame> {
  // constructor(
  //   frame: AutoAnimationFrame,
  //   relationships: AnimationFrameRelationships,
  // ) {
  //   super(frame, relationships);
  // }

  get type() {
    return this.frame.type as 'appear' | 'disappear';
  }
  get targetShape(): RootShape {
    return this.rootMainFrame.shape as RootShape;
  }
  setShapesToAnimate() {
    this.shapesToAnimate = [
      this.shapeService.getShapeByIRI(this.frame.targetShape),
    ];
  }

  translate: Translate;
  _targetShape: GeneralShape;
  startAnimations(numberOfBatches: number, timeScale: number): void {
    // this.setShapesToAnimate();
    // console.log('startAnimations', numberOfBatches);
    this._targetShape = this.getTargetShape();
    // -- // -- // -- // -- //

    switch (this.frame.action) {
      // -- // -- // -- //
      case 'appear':
        this._targetShape._hide();
        if (this.frame.alignment) {
          // console.log('appear.prepareDoAlign', this.frame.alignment); //
          // this._targetShape.doAlign(this.frame.alignment, { noResize: true });
          this._targetShape.doAlign(this.frame.alignment);
        }

        this._targetShape.prepareKeyValueAnimation(
          {
            key: 'show-hide',
            value: { value: true } as AppearAnimation,
          },
          numberOfBatches,
          timeScale,
        );
        break;
      case 'disappear':
        this._targetShape.prepareKeyValueAnimation(
          {
            key: 'show-hide',
            value: { value: false } as AppearAnimation,
          },
          numberOfBatches,
          timeScale,
        );
        break;
      case 'move':
        if (this._targetShape.getType() == 'image-shape') {
          this.translate = (
            this._targetShape as ImageShape
          ).getTranslateByAlign(this.frame.alignment);
        } else {
          this.translate = this._targetShape.doAlign(this.frame.alignment);
          // console.log('start move animation > alignment', this.frame.alignment); //
          // this.translate = this._targetShape.doAlign(this.frame.alignment, {
          //   noApply: true,
          //   noResize: true,
          // });
          // -- // -- // -- //
        }

        this._targetShape.prepareKeyValueAnimation(
          {
            key: 'translate',
            value: this.translate,
          },
          numberOfBatches,
          timeScale,
        );

        break;
    }
  }

  async executeAnimation(timeScale: number): Promise<void> {
    this.currentIncrement = 0;
    const numberOfBatches = Math.floor(
      this.duration * timeScale * this.cs.batchPerSecond,
    );
    this.startAnimations(numberOfBatches, timeScale);

    this.animationId = Math.random().toString() + Math.random().toString();

    // console.log('execute-animation > number of batches', numberOfBatches); //
    return new Promise(resolve => {
      this.service.animationFrames[this.animationId] = increment => {
        // console.log('increment', increment, this._targetShape);
        this.currentIncrement += increment;
        let end = false;
        if (this.currentIncrement >= numberOfBatches) {
          end = true;
          // Occasional overflow is eliminated //
          increment -= this.currentIncrement - numberOfBatches;
        }

        switch (this.frame.action) {
          case 'appear':
          case 'disappear':
            this._targetShape.incrementAnimationByKey('show-hide', increment);
            break;
          case 'move':
            this._targetShape.incrementAnimationByKey('translate', increment);
            break;
          case 'text':
            // -- // -- //
            break;
        }

        // this._targetShape.incrementAnimation(increment);
        if (end) {
          // -- // -- //
          switch (this.frame.action) {
            case 'appear':
              this._targetShape.endAnimationByKeyValue('show-hide', {
                value: true,
              });
              break;
            case 'move':
              this._targetShape.endAnimationByKeyValue(
                'translate',
                this.translate,
              );
              break;
          }
          // -- //
          delete this.service.animationFrames[this.animationId];
          resolve();
        }
      };
    });
  }

  endAnimations(): void {
    // console.log('--------- end-animations -----------');
    this._targetShape.endBaseAnimation();
  }
}
